import { GridCellProps } from '@progress/kendo-react-grid';
import { useGridState } from '@techsharegov/react-ui';
import React from 'react';

export type ConditionalDetailColumnCellProps = GridCellProps & {
  condition?: boolean;
  matchField: string;
};

export const ConditionalDetailColumnCell: React.FC<
  ConditionalDetailColumnCellProps
> = ({ dataItem, condition = false, matchField = 'id' }) => {
  const { data, setData } = useGridState();
  const className = dataItem.expanded ? 'k-icon k-minus' : 'k-icon k-plus';
  const onExpandChange = (dataItem: any) => {
    if (data != null && (data as any[]).length > 0) {
      let newData = (data as any[]).map((item: any) => {
        if (item[matchField] === dataItem[matchField]) {
          item.expanded = !dataItem.expanded;
        }
        return item;
      });
      setData(newData);
    }
  };

  if (condition) {
    return (
      <td className="k-hierarchy-cell">
        <a
          onClick={() => onExpandChange(dataItem)}
          className={className}
          href="#"
          tabIndex={-1}
        ></a>
      </td>
    );
  }
  return <td className="k-hierarchy-cell" />;
};
